window._ = require("lodash");

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require("popper.js").default;
    window.$ = window.jQuery = require("jquery");
    window.trumbowyg = require("trumbowyg");
    $(".trumbowyg-editor").trumbowyg({
        minimalLinks: true,
        btns: [
            [
                "strong",
                "em",
                "link",
                "h2",
                "h3",
                "p",
                "removeformat",
                "viewHTML",
            ],
        ],
        svgPath: "/assets/svg/trumbowyg-icons.svg",
    });
    window.select2 = require("select2");
    window.selectize = require("selectize");
    window.DataTable = require("datatables.net-bs4");

    // Initialize any tables with class 'datatable'
    $(".datatable").DataTable({
        ordering: false,
        pageLength: 20,
        layout: {
            topStart: null,
            topEnd: "search",
            bottomStart: null,
            bottomEnd: null,
            bottom: "paging",
        },
    });

    require("bootstrap");
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");
window.slick = require("slick-carousel");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

import "./interface";
import "./interface/autosave";
// import './select-2-tree';
import "./billing";
// Import Ion Rangeslider
import ionRangeSlider from "ion-rangeslider";
window.ionRangeSlider = ionRangeSlider;
import "./front/hs-mask";
import "./front/appear";
import "./front/circles";
import "./front";
// import './front/hs-slick-carousel';
import "./front/hs-header";
import "./front/hs-unfold";
import "./front/hs-show-animation";
import "./front/hs-toggle-switch";
